import { Form } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';

export const componentPool = {
  ...Form,
  Number: Form.Input,
  'Short Text': Form.Input,
  Picklist: Form.Dropdown,
  Date: DatePicker,
  Email: Form.Input,
  Phone: Form.Input,
  'Long Text': Form.TextArea,
};



// WEBPACK FOOTER //
// ./src/helpers/componentPool.js